export default "__VITE_ASSET__JlOw5n$$__"